import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import { Link } from "react-router-dom";
import moment from 'moment';
import { DATATABLE_CONFIG, PUNCH_EDITING_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility'
import * as actions from '../../../store/actions/index';


class PunchEditing extends Component {
    state = {
        display : true,
        globalFilter: null,
        selectedCustomers:[],
        selectedEmployee:null,
    }
    




    deleteDocType = () => {

        if(this.state.selectedCustomers.length > 0){


        const updatedDocValue = this.state.selectedCustomers.map( value => {
            return value.code;
        })
        const filteredValue = this.state.dataTableValue.filter(doc => {

            return updatedDocValue.includes(doc.code) === false;
         
        });
        this.setState({dataTableValue:filteredValue})
        }
        else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select checkbox'});
        }

        // const updatedDeptValue = this.state.dataTableValue.filter((value,index) => {
        //     return removeIndex !== index;
        // })
        // this.setState({dataTableValue:updatedDeptValue})

    }


    onEmployeeChange = (event) => {
        this.dt.filter(event.value, 'employeeName', 'equals');
        this.setState({selectedEmployee: event.value});
    }

    componentDidMount(){    
        this.props.getMasterKeywordList('Employee');
        const hrTeam = parseInt(localStorage.getItem('hrTeam'));
        this.props.fetchSubordinatesLists(this.props.loggedUserDetail.empID, this.props.loggedUserDetail.CompanyId);           
        this.getAccess = HASACCESS(PUNCH_EDITING_SUBMENU_ID);
        
    }


    actionTemplate = (rowData, column) => {
        //let rowIndex = column.rowIndex;
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
        <Link to={"/Punch/edit/"+rowData.empBookingId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }
            {/* {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
        <Link to={"/Project/view/"+rowData.projectid}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            } */}
        </div>;
    }


    loadData(){
        const { selectedEmployee, fromDate, toDate } = this.state;
        if (!selectedEmployee || !fromDate || !toDate) {
            this.growl.show({severity: 'error', summary: null, detail: 'Please select Employee, From Date and To Date'});
            return;
        }
        const fromDt = moment(fromDate).format('YYYY-MM-DD');
        const toDt = moment(toDate).format('YYYY-MM-DD');
        this.props.getMasterTableList(`GetTimeBooking?Id=${selectedEmployee}&FromDt=${fromDt}&ToDt=${toDt}`);
    }

  
    render() { 
        
        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }






        
    
        const hrTeam = parseInt(localStorage.getItem('hrTeam'));
        let relevantOptions = [];
        if (hrTeam) {
            relevantOptions = this.props.Employee.reduce((a, el) => {
                if (el.value !== this.props.loggedUserDetail.empID) {
                    a.push(el);
                }
                return a;
            }, [Object.assign({}, this.props.Employee.find(list => list.value === this.props.loggedUserDetail.empID), {label: 'Self', id: this.props.loggedUserDetail.userID})]);
        } else {
            relevantOptions = (this.props.loggedUserDetail!==null) ? [{label: 'self', value: this.props.loggedUserDetail.empID, id: this.props.loggedUserDetail.userID}].concat(this.props.subordinatesListData) : this.props.subordinatesListData;
        }

        let tableData = [];
        tableData = this.props.tableLists;


        

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );
        
        return (
            <div className="p-grid approvalPath">
                <Toast ref={(el) => this.growl = el} />
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Time-Machine Log</h1>
               
                        <div className="p-grid">

                        <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Select Employee<span className="requiredColor">*</span></label>
                            <div className="mt1 ">
                            <Dropdown style={{width: '100%'}} placeholder="Select Employee" value={this.state.selectedEmployee} options={relevantOptions} showClear onChange={this.onEmployeeChange} />
                            </div>                                
                        </div>

                                
                            <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">From Date<span className="requiredColor">*</span></label>
                                <div className="mt1">
                                <Calendar    style={{width:'100%'}} placeholder="From Date" showIcon={false} name="fromDate" value={this.state.fromDate} onChange={(e) => this.setState({fromDate:e.target.value})} />
                                </div>                                
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-3">
                            <label className="label">To Date<span className="requiredColor">*</span></label>
                                <div className="mt1">
                                <Calendar   style={{width:'100%'}} placeholder="To Date" showIcon={false} name="toDate" value={this.state.toDate} onChange={(e) => this.setState({toDate:e.target.value})}  />
                                </div>                                
                            </div>
                            <div className="p-col-12 p-md-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                    <Link to="/Punch/add/new"><Button style={{float: 'right'}} label="Add TimeLog" icon="pi pi-plus" className="ml1" /></Link>
                                }
                                </div>
                                </div>
                            <div className="p-col-12 p-md-12">
                                <div className="mt1">
                                    <Button  style={{float: 'right'}} label="View" className="p-button-primary" onClick={() => {this.loadData()}
                                    }/>
                                </div>                                
                            </div>
                                                
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                     
                        <DataTable ref={(el) => this.dt = el} value={tableData} responsive className="p-datatable-customers animated fadeIn" rowHover 
                         selection={this.state.selectedCustomers} onSelectionChange={e => this.setState({selectedCustomers: e.value})}
                         paginator rows={30} emptyMessage="No data found" globalFilter={this.state.globalFilter} header={header}  >
                                
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="employeename" header="Employee Name" />
                                <Column field="date" header="Date" sortable={true} />
                                <Column field="time" header="Time" sortable={true} />
                                <Column field="trxType" header="In / Out" sortable={true} />
                                {/* <Column field="hours" header="Hours" sortable={true} />
                                <Column field="dayRegular" header="Day Regular Total" sortable={true} />
                                <Column field="dayOf" header="Day of Total" sortable={true} /> */}
                                <Column body={this.actionTemplate} header="Action" />
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = state => {
    return{
        Employee : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        subordinatesListData: state.master.subordinatesListData
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(PunchEditing);